import { useTranslation } from 'react-i18next';

import { Empty } from '../../components/ui/States';

/** Pestañas que llegan con su tarea (Fase 1–2): el layout ya las muestra. */
export function ChartTabSoon() {
  const { t } = useTranslation();
  return (
    <section className="card">
      <Empty title={t('common.sectionComingSoon')} />
    </section>
  );
}
